/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Group from 'entities/Group';
import SmsInstruction from 'users/components/SmsInstruction';

class JoinDeviceBlockModal extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    group: PropTypes.instanceOf(Group).isRequired,
  };

  render() {
    const { group, ...props } = this.props;

    return (
      <Dialog
        {...props}
        title="We cannot send you a code"
        subtext="Sign up via text below"
        className="JoinDeviceBlockModal">
        <BoxBody divided>
          <SmsInstruction group={group} />
        </BoxBody>
      </Dialog>
    );
  }
}

export default JoinDeviceBlockModal;
